<template>
  <section id="oferta2" class="section-shell offer2-section" data-theme="climax">
    <div class="offer2-header" data-reveal>
      <p class="eyebrow">Acesso completo desde o primeiro dia</p>
      <h2>O mesmo sistema em todos os planos. <span class="offer2-sub">Muda s&oacute; o tempo de compromisso.</span></h2>
    </div>

    <div class="offer2-grid" data-reveal>
      <article
        v-for="plan in plans"
        :key="plan.key"
        class="offer2-card"
        :class="{ featured: plan.featured }"
      >
        <p class="offer2-kicker">
          <span class="offer2-name">{{ plan.name }}</span>
          <span v-if="plan.savings" class="offer2-save">{{ plan.savings }}</span>
        </p>

        <div class="offer2-pricewrap">
          <p class="offer2-price">
            {{ plan.perMonth }}<span class="offer2-permonth">/m&ecirc;s</span>
          </p>
          <p class="offer2-pixtag">
            <strong>{{ plan.pix }}</strong>
            <span class="pixtag-label">no PIX</span>
          </p>
        </div>

        <p class="offer2-total">{{ plan.total }}</p>
        <p class="offer2-hook">{{ plan.hook }}</p>

        <span v-if="plan.featured" class="offer2-chip">
          <i class="fas fa-crown" aria-hidden="true"></i>
          MAIS ESCOLHIDO
        </span>

        <button
          class="offer2-cta"
          :class="plan.featured ? 'cta primary offer2-cta-primary' : 'offer2-cta-ghost'"
          @click="emit('cta', plan.key)"
        >
          {{ plan.cta }}
        </button>
      </article>
    </div>

    <div class="offer2-trust" data-reveal>
      <span>Acesso imediato ap&oacute;s confirma&ccedil;&atilde;o</span>
      <span class="trust-sep" aria-hidden="true"></span>
      <span>Garantia de at&eacute; 7 dias para reembolso</span>
    </div>
  </section>
</template>

<script setup>
import { getCurrentInstance } from 'vue';

const instance = getCurrentInstance();
const emit = instance ? instance.emit : () => {};

const plans = [
  {
    key: 'mensal',
    name: 'MENSAL',
    perMonth: '97,00',
    total: '97,00 no total · renova todo mês',
    pix: '92,15',
    savings: null,
    hook: 'Testa o sistema no seu ritmo.',
    cta: 'Começar agora',
    featured: false,
  },
  {
    key: 'trimestral',
    name: 'TRIMESTRAL',
    perMonth: '82,33',
    total: '247,00 no total · 3 meses',
    pix: '234,65',
    savings: '−15% vs mensal',
    hook: 'Tempo pra leitura virar hábito.',
    cta: 'Entrar no ritmo',
    featured: false,
  },
  {
    key: 'semestral',
    name: 'SEMESTRAL',
    perMonth: '74,50',
    total: '447,00 no total · 6 meses',
    pix: '353,88',
    savings: '−23% vs mensal',
    hook: 'Menos de 2,50 por dia.',
    cta: 'Virar o jogo',
    featured: true,
  },
  {
    key: 'anual',
    name: 'ANUAL',
    perMonth: '66,42',
    total: '797,00 no total · 12 meses',
    pix: '630,80',
    savings: '−31% vs mensal',
    hook: 'Preço de quem pensa em ciclos.',
    cta: 'Garantir o ano',
    featured: false,
  },
];
</script>

<style scoped>
.offer2-section {
  display: grid;
  gap: 22px;
  border-radius: 24px;
  border: 1px solid rgba(115, 148, 240, 0.18);
  background:
    radial-gradient(circle at 12% 12%, rgba(78, 115, 223, 0.14), transparent 34%),
    radial-gradient(circle at 86% 10%, rgba(155, 89, 182, 0.12), transparent 30%),
    linear-gradient(180deg, rgba(9, 12, 22, 0.96), rgba(7, 9, 16, 0.98));
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif !important;
}

.offer2-section,
.offer2-section * {
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif !important;
}

.offer2-header {
  display: grid;
  gap: 6px;
}

.offer2-header h2 {
  margin: 0;
  color: #eef3ff;
  font-size: clamp(1.5rem, 2.4vw, 2.2rem);
  line-height: 1.14;
  letter-spacing: -0.02em;
}

.offer2-sub {
  display: block;
  color: #aebcdd;
  font-size: clamp(1.05rem, 1.5vw, 1.3rem);
  font-weight: 500;
  font-style: italic;
}

.offer2-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  align-items: stretch;
  padding-top: 10px;
}

.offer2-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 9px;
  padding: 20px 18px 18px;
  border-radius: 18px;
  border: 1px solid rgba(129, 158, 240, 0.22);
  background:
    radial-gradient(circle at 100% 0%, rgba(155, 89, 182, 0.08), transparent 36%),
    linear-gradient(160deg, rgba(17, 22, 38, 0.96), rgba(10, 14, 26, 0.94));
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.05),
    0 14px 36px rgba(0, 0, 0, 0.24);
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.offer2-card:hover {
  transform: translateY(-4px);
  border-color: rgba(150, 178, 250, 0.42);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    0 20px 44px rgba(0, 0, 0, 0.34),
    0 0 22px rgba(115, 148, 240, 0.16);
}

.offer2-card.featured {
  transform: translateY(-8px) scale(1.03);
  border-color: rgba(170, 198, 255, 0.55);
  background:
    radial-gradient(circle at 84% 8%, rgba(155, 89, 182, 0.18), transparent 36%),
    radial-gradient(circle at 12% 100%, rgba(78, 115, 223, 0.16), transparent 40%),
    linear-gradient(160deg, rgba(24, 31, 54, 0.98), rgba(13, 18, 34, 0.96));
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.1),
    0 22px 52px rgba(0, 0, 0, 0.36),
    0 0 0 1px rgba(140, 172, 252, 0.2),
    0 0 30px rgba(115, 148, 240, 0.22);
  animation: offer2-featured-glow 3.2s ease-in-out infinite alternate;
  z-index: 1;
}

.offer2-card.featured:hover {
  transform: translateY(-11px) scale(1.03);
}

@keyframes offer2-featured-glow {
  0% {
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.1),
      0 22px 52px rgba(0, 0, 0, 0.36),
      0 0 0 1px rgba(140, 172, 252, 0.2),
      0 0 24px rgba(115, 148, 240, 0.18);
  }
  100% {
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.1),
      0 22px 52px rgba(0, 0, 0, 0.36),
      0 0 0 1px rgba(150, 182, 255, 0.32),
      0 0 38px rgba(140, 120, 240, 0.34);
  }
}

.offer2-kicker {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 6px;
  margin: 0;
}

.offer2-name {
  color: #eef4ff;
  font-size: 1.02rem;
  font-weight: 800;
  letter-spacing: 0.13em;
  text-transform: uppercase;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.06), 0 6px 18px rgba(8, 14, 30, 0.4);
  position: relative;
  padding-bottom: 6px;
}

.offer2-name::after {
  content: '';
  position: absolute;
  left: 1px;
  bottom: 0;
  width: 26px;
  height: 2px;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(122, 162, 255, 0.95), rgba(189, 145, 255, 0.4));
}

.offer2-card.featured .offer2-name::after {
  width: 38px;
  background: linear-gradient(90deg, #7aa2ff, #bd8bff);
  box-shadow: 0 0 10px rgba(122, 162, 255, 0.5);
}

.offer2-save {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  padding: 3px 7px 3px 8px;
  border-radius: 2px 9px 2px 9px;
  border: 1px solid rgba(56, 211, 159, 0.28);
  border-left: 2px solid rgba(56, 211, 159, 0.9);
  background: linear-gradient(90deg, rgba(56, 211, 159, 0.13), rgba(56, 211, 159, 0.03));
  color: #7fe9c0;
  font-family: var(--landing-font-mono) !important;
  font-size: 0.56rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  white-space: nowrap;
}

.offer2-pricewrap {
  display: grid;
  gap: 7px;
  justify-items: start;
  margin-top: 2px;
}

.offer2-price {
  margin: 0;
  color: #f6fbff;
  font-size: clamp(2rem, 2.8vw, 2.55rem);
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.02em;
}

.offer2-permonth {
  color: #93a5c9;
  font-size: 0.95rem;
  font-weight: 600;
  margin-left: 2px;
}

.offer2-pixtag {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin: 0;
  padding: 6px 11px;
  border-radius: 9px 2px 9px 2px;
  border: 1px solid rgba(56, 211, 159, 0.32);
  background: linear-gradient(120deg, rgba(56, 211, 159, 0.16), rgba(56, 211, 159, 0.04));
  box-shadow: 0 0 14px rgba(56, 211, 159, 0.12);
}

.offer2-pixtag strong {
  color: #eafff6;
  font-size: 0.98rem;
  font-weight: 800;
  line-height: 1;
  letter-spacing: 0.01em;
}

.pixtag-label {
  color: #7fe9c0;
  font-family: var(--landing-font-mono) !important;
  font-size: 0.6rem;
  font-weight: 600;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  line-height: 1;
}

.offer2-total {
  margin: 0;
  color: #9aa9cc;
  font-size: 0.84rem;
  font-style: italic;
  letter-spacing: 0.01em;
}

.offer2-hook {
  margin: 0;
  color: #c3d0eb;
  font-size: 0.92rem;
  font-style: italic;
  line-height: 1.35;
}

.offer2-card.featured .offer2-hook {
  color: #97efc7;
  font-weight: 700;
}

.offer2-chip {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 13px;
  border-radius: 2px 10px 2px 10px;
  border: 1px solid rgba(170, 200, 255, 0.42);
  border-left: 2px solid rgba(186, 208, 255, 0.95);
  background: linear-gradient(120deg, rgba(52, 78, 160, 0.98), rgba(108, 62, 150, 0.98));
  color: #eef4ff;
  font-family: var(--landing-font-mono) !important;
  font-size: 0.64rem;
  font-weight: 700;
  letter-spacing: 0.09em;
  white-space: nowrap;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.4);
}

.offer2-chip i {
  font-family: 'Font Awesome 5 Free' !important;
  font-weight: 900;
  font-size: 0.68rem;
  color: #ffd982;
  filter: drop-shadow(0 0 4px rgba(255, 205, 110, 0.55));
}

.offer2-cta {
  margin-top: auto;
  width: 100%;
  min-height: 46px;
  padding: 11px 14px;
  font-size: 0.95rem;
  border-radius: 999px;
  cursor: pointer;
}

.offer2-cta-primary {
  font-weight: 700;
}

.offer2-cta-ghost {
  border: 1px solid rgba(130, 164, 246, 0.36);
  background: rgba(15, 20, 36, 0.6);
  color: #dbe6ff;
  font-weight: 600;
  letter-spacing: 0.01em;
  transition: border-color 0.18s ease, background 0.18s ease, box-shadow 0.18s ease;
}

.offer2-cta-ghost:hover {
  border-color: rgba(170, 196, 255, 0.6);
  background: rgba(24, 32, 56, 0.78);
  box-shadow: 0 0 18px rgba(115, 148, 240, 0.2);
}

.offer2-trust {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  margin: 0;
  color: #8fa0c2;
  font-family: var(--landing-font-mono) !important;
  font-size: 0.72rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.offer2-trust span {
  font-family: var(--landing-font-mono) !important;
}

.trust-sep {
  width: 5px;
  height: 5px;
  transform: rotate(45deg);
  background: linear-gradient(135deg, rgba(130, 164, 246, 0.8), rgba(155, 89, 182, 0.7));
  border-radius: 1px;
}

@media (max-width: 980px) {
  .offer2-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    row-gap: 20px;
  }

  .offer2-card.featured {
    transform: none;
  }

  .offer2-card.featured:hover {
    transform: translateY(-4px);
  }
}

@media (max-width: 560px) {
  .offer2-grid {
    grid-template-columns: 1fr;
    padding-top: 14px;
  }

  .offer2-card.featured {
    order: -1;
  }

  .offer2-trust {
    gap: 10px;
    font-size: 0.66rem;
  }
}
</style>
